import noop from 'lib/function/noop'
import { createContext } from 'react'

export interface TripMapContextValue {
  onSelectMapItem: (sectionId: string) => void
  onDeselectMapItem: () => void
}

export const TripMapContext = createContext<TripMapContextValue>({
  onSelectMapItem: noop,
  onDeselectMapItem: noop,
})
